import PropTypes from 'prop-types';

export const propTypes = {
  additionalNavClass: PropTypes.string,
  adminifiDomain: PropTypes.string,
  appendLanguage: PropTypes.bool,
  currentRuleSets: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
    })
  ),
  helpMessage: PropTypes.string,
  helpMessageEnabled: PropTypes.bool,
  hideNameOnMobile: PropTypes.bool,
  homeroomDomain: PropTypes.string,
  isFoundry: PropTypes.bool,
  isHomeroom: PropTypes.bool,
  isImpersonating: PropTypes.bool,
  isMobile: PropTypes.bool,
  languages: PropTypes.object,
  menuData: PropTypes.shape({
    submenu_items: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.string,
        title: PropTypes.string.isRequired,
        /** if you set the css class to account, the menu item will have a different set of style rules */
        css_class: PropTypes.string,
        target_url: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        /** this will indicate if the menu item is either a Link or a Dropdown */
        submenu_items: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string.isRequired,
            target_url: PropTypes.string.isRequired,
            target_method: PropTypes.string,
            new_window: PropTypes.bool.isRequired,
            slug: PropTypes.string.isRequired,
          })
        ),
      })
    ),
  }).isRequired,
  onStopImpersonation: PropTypes.func,
  organizationSlug: PropTypes.string,
  pullRight: PropTypes.bool,
  selectedLanguage: PropTypes.string,
  showCloseButton: PropTypes.bool,
  user: PropTypes.object,
  windowOverride: PropTypes.object,
};

export const defaultProps = {
  hideNameOnMobile: true,
  menuData: {},
  pullRight: true,
  showCloseButton: true,
  user: null,
};

export interface SubmenuItem {
  title: string;
  target_url: string;
  target_method?: string;
  new_window: boolean;
  slug: string;
  icon?: string;
  css_class?: string;
  sub_text?: string;
  subsection?: boolean;
}

export interface MenuItem {
  icon?: string;
  title: string;
  css_class?: string;
  new_window: boolean;
  target_method?: string;
  target_url: string;
  slug: string;
  submenu_items?: SubmenuItem[];
}

interface MenuData {
  submenu_items: MenuItem[];
}

interface RuleSet {
  active: boolean;
  name?: string;
}

interface User {
  [key: string]: any;
}

interface Languages {
  [key: string]: any;
}

export interface HeaderMenuProps {
  menuData: MenuData;
  additionalNavClass?: string;
  adminifiDomain?: string;
  appendLanguage?: boolean;
  currentRuleSets?: RuleSet[];
  helpMessage?: string;
  helpMessageEnabled?: boolean;
  hideNameOnMobile?: boolean;
  homeroomDomain?: string;
  isFoundry?: boolean;
  isHomeroom?: boolean;
  isImpersonating?: boolean;
  isMobile?: boolean;
  languages?: Languages;
  onStopImpersonation?: () => void;
  organizationSlug?: string;
  pullRight?: boolean;
  selectedLanguage?: string;
  showCloseButton?: boolean;
  user?: User | null;
  windowOverride?: typeof window;
}
